import React, { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';

import { InputTextarea } from 'primereact/inputtextarea';
import CompetitionUtils from '../../utilities/CompetitionUtils';

const CompetitionChangeReasonDialog = (props) => {
    const [competition, setCompetition] = useState(null);

    const toast = useRef(null);

    useEffect(() => {
        setCompetition({
            ...props.value,
            changeReason: props.value.changeReason ? props.value.changeReason : ''
        });        

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        formik.resetForm();
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: competition ? competition : props.value,
        validate: (data) => {
            let errors = {};

            if (!data.changeReason || data.changeReason.trim() === '') {
                errors.changeReason = translatedMessage('form.error.changeReason.required');
            }

            return errors;
        },
        onSubmit: (data) => {
            if (typeof props.afterSave === 'function') {
                props.afterSave(props.action, data);
            }
            hideDialog();
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    const formDialogFooter = (
        <>
            <Button label={translatedMessage('generic.close')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={CompetitionUtils.getAcceptButtonLabelForAction(props.action)} icon="pi pi-check" className="p-button p-button-primary" form="changeReason-form" type="submit" />
        </>
    );

    const formDialogHeader = (
        <>
            {CompetitionUtils.getDialogTitleForAction(props.action)}
            <div className='mt-2 text-default'>{CompetitionUtils.getDialogInfoForAction(props.action)}</div>
        </>
    );

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={props?.visible}
                header={formDialogHeader}
                modal
                className="pcn-dialog p-fluid"
                footer={formDialogFooter}
                onHide={hideDialog}
            >
                <form id="changeReason-form" onSubmit={formik.handleSubmit}>
                    <div className='grid'>
                        <div className='col-12'>
                            <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <InputTextarea
                                        type="text"
                                        id="changeReason"
                                        name="changeReason"
                                        value={formik.values.changeReason}
                                        onChange={formik.handleChange}
                                        className={classNames({ 'p-invalid': isFormFieldValid('changeReason') })}
                                        rows={5} cols={30}
                                        autoResize
                                        autoFocus
                                    />
                                    <label htmlFor="changeReason" className={classNames({ 'p-error': isFormFieldValid('changeReason') })}>
                                        {translatedMessage('competition.changeReason')} *
                                    </label>
                                </span>
                            </div>
                            {getFormErrorMessage('changeReason')}
                        </div>
                    </div>
                </form>
            </Dialog >
        </>
    );
};

export default CompetitionChangeReasonDialog;
